module.exports = __webpack_public_path__ + "static/media/mtwo.901c215f.png";